<template>
  <div class="flex flex-col gap-4">
    <USkeleton class="aspect-4/3 rounded" />
    <div class="flex flex-col gap-2.5">
      <USkeleton class="h-4.5 w-3/4" />
      <USkeleton class="h-3.75 w-1/3 mt-1" />
    </div>
  </div>
</template>
